export default __webpack_public_path__ + "static/media/Inter-ExtraBoldItalic.a0a103e5.woff2";